/* eslint-disable no-console, eol-last, import/no-duplicates,  import/no-extraneous-dependencies, import/order */
import '@interactjs/actions/plugin'
import interact from '@interactjs/interact/index'
import plugin from '@interactjs/actions/plugin'
interact.use(plugin)